import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const http = axios.create({ baseURL: API });

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -72 });
  else el.scrollIntoView({ behavior: "smooth" });
};

export const errText = (e) => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg).filter(Boolean).join(" ");
  return "Something went wrong. Please try again.";
};

export const money = (n) =>
  new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 0 }).format(n || 0);

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1556740720-776b84291f8e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  retail: "https://images.unsplash.com/photo-1556742031-c6961e8560b0?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  online: "https://images.unsplash.com/photo-1654263937079-f63a3ea4d48b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  mobile: "https://images.pexels.com/photos/5239810/pexels-photo-5239810.jpeg?auto=compress&cs=tinysrgb&w=1200",
  payroll: "https://images.unsplash.com/photo-1542744173-8e7e53415bb0?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  review: "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
};

export const SERVICES = ["Retail POS", "Online / E-commerce", "Mobile payments", "Payroll"];
export const BUSINESS_TYPES = ["Retail store", "Restaurant / Food", "Online / E-commerce", "Mobile / Field services", "Professional services", "Other"];
export const ILLUSTRATIVE_RATE = 2.0;
